/*global chrome*/

import React from 'react';

// Components
import ssExample from '../../../img/screen-share.jpeg'

const ShareScreen = class ShareScreen extends React.Component {
  constructor() {
    super();

    // Set the initial state
    this.state = {
      finished: false
    };
  }

  componentDidUpdate() {
    const { button, nextStep, parent, sessionStartData, statusClass, proctorApproved } =
      this.props;
    const { SessionStore } = this.props.store;

    if (statusClass === 'slide-active' && parent.state.next !== nextStep) {
      // Skip if not enabled
      if (!sessionStartData.modalityOptions.recordScreen) {
        nextStep();
      }

      if (!button.disabled && !this.state.finished) {
        // Disable the continue button
        button.disabled = true;

        parent.setState({
          next: null
        });
      }
      
      // Listen for sharing complete
      const shareDelay = setInterval(() => {
        chrome.runtime.sendMessage(
          SessionStore.extensionInfo.extensionId,
          { message: 'isRecording' },
          response => {
            if (response.isScreenRecording) {
              clearInterval(shareDelay);

              if (!this.state.finished) {
                this.setState(
                  {
                    finished: true
                  },
                  () => {
                    nextStep();
                  }
                );
              }
            }
          }
        );
      }, 1000);
    }
    // Case for enabling continue button if student gets stuck on ScreenShare while still being
    if (statusClass === 'slide-active' && button.disabled && proctorApproved) {
      button.disabled = false;
    }
  }

  render() {
    const { onShowPopup, statusClass } = this.props;
    const translation = this.props.translation.share_screen;

    return (
      <main className={`panel panel--medium ${statusClass}`} aria-labelledby="step7">
        <h2 className="panel__title panel__title--alt" id="step7">
          {translation.heading}
        </h2>

        <p>{translation.body}</p>

        <p className="note">
          {translation.screen_share_note}
        </p>

        <img className="img" role="presentation" src={ssExample} alt="Steps for successful Screen Share"/>

        <p className="note">
          <b>{translation.keyboard_note}</b>
          {translation.keyboard_note2}
        </p>

        <button className="btn" onClick={onShowPopup}>
          {translation.button}
        </button>
      </main>
    );
  }
};

export default ShareScreen;



// WEBPACK FOOTER //
// ./src/app/components/SessionStart/ShareScreen.js